<template>
  <canvas  :ref="ref"></canvas>
</template>

<script>

import Chart from 'chart.js';



export default {

  props: ['data'],

  name: '',
  data() {
    return {
      ref: `pie-${Math.random().toString(36).substring(7)}`,
	  myChart:undefined
    };
  },
  mounted() {
    const chart = this.$refs[this.ref];
    const ctx = chart.getContext('2d');
    this.myChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: [
          'fouten',
          'aangevraagd',
          'ontvangen',
        ],
        datasets: [{
          data: [],
          backgroundColor: [
            '#d5535f',
            '#38885f',
            '#2e5f40',
          ],
          borderColor: [
            '#d5535f',
            '#38885f',
            '#2e5f40',
          ],
          hoverBackgroundColor: [
            '#cd404d',
            '#2d7e55',
            '#245837',
          ],
          borderWidth: 1,
        }],
      },
      options: {
        plugins: {
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
         legend: {
            display: false
         },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [],
          yAxes: [],
        },
        title: {
          display: true,
        },
      },
    });
  },
 watch: {
	data: function(newVal, oldVal)
	{
		let labels = [];
		let data = [];
		for(var i in newVal)
		{
			labels[i] = newVal[i].state;
			data[i] = newVal[i].amount;
		}
    this.myChart.data.labels = labels;
		this.myChart.data.datasets[0].data = data;
		this.myChart.update();
	}
  }
};
</script>
